import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { Profile } from 'src/app/assabil-kernel/models/entities/master-data/profile-entity';
import { AssabilMenuLovComponent } from '../../../control-tables/assabil-menu-lov/assabil-menu-lov.component';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';


@Component({
  selector: 'profile-list',
  templateUrl: './profile-list.component.html',
  styleUrls: ['./profile-list.component.scss']
})

export class ProfileListComponent extends BasePage2<Profile> {

  profiles     : Profile[] = [];
  code      : string;
  name      : string;

  constructor(   
    protected toastr                : ToastrService,
    protected router                : Router,
    protected controlTablesService  : ControlTablesService,
    protected baseService           : BaseService,
    protected leanUtilsService      : LeanUtilsService,
    protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "profile";
  }


//----------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.setChildFields();
}
//----------------------------------------------------------------------

//----------------------------------------------------------------------
setChildFields(){
      this.baseService.fieldsGet('profileAssabilMenu').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'assabilMenu.assabilMenuCode') {
                   field.modal = AssabilMenuLovComponent;
                }
            })

      }) 
  }
//----------------------------------------------------------------------


//----------------------------------------------------------------------
getRows(): Profile[] {
      return this.profiles;
}
//----------------------------------------------------------------------



//----------------------------------------------------------------------
new(){
  let form : Profile = new Profile();
  form.inserted = true;
  form.edit     = true;
  this.selectedRow = form;
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
  loadData() {    
    let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
    request.strArg1 = this.code;
    request.strArg2 = this.name;
    this.controlTablesService.getList(this.entityName, request).then(result => {
        this.profiles = result;
    })
  }
// ---------------------------------------------------
  
//----------------------------------------------------------------------
selectRow(profile : Profile){
  let request: BaseRequest = new BaseRequest(this.controlTablesService.getUserInfo());
  request.strArg1 = profile.profileCode;
  this.controlTablesService.getSingle(this.entityName, request).then(result => {
    console.log(result);
      this.selectedRow = result;
  })
}
//----------------------------------------------------------------------

}
